module.exports = __webpack_public_path__ + "img/Product02.c3cd20e5.png";